export default __webpack_public_path__ + "static/media/Doctor_HTB.e8ae31cb.md";